/* eslint-disable consistent-return */
import { Bert } from 'meteor/themeteorchef:bert';

import methodPromise from '../../modules/method-promise-wrapper';

/**
 * Fetchs one style from the database.
 *
 * @async
 * @param {string} styleId - The style id.
 * @returns {object|undefined} Returns the style from the database or undefined if not found.
 * @throws {Error} Meteor Error if anything goes wrong.
 */
export const styleFetchOne = async styleId => {
  try {
    const style = await methodPromise('styles.fetchOne', styleId);
    return style;
  } catch (error) {
    Bert.alert(error.reason, 'danger');
  }
};

export default { styleFetchOne };
